

export const featurePaths = {
    EfairsJobList: "/efairsjoblist",
    CreateEfairsJob: "/efairsjoblist/createefairsjob",
    EditEfairsJob: "/efairsjoblist/editefairsjob",
     AddmultipleService: "/efairsjoblist/editefairsjob/addmultipleservice",


} as const;

// export const apiPaths = {
//     getAllTransportCodes: "/api/TransportCode/GetAllTransportCodes",
//     createTransportCode: "/api/TransportCode/CreateTransportCode",
//     updateTransportCode: "/api/TransportCode/UpdateTransportCode",
// } as const;